import React from "react";
import { Outlet } from "react-router-dom";
import SidebarProjetos from "../componentes/Sidebar/SidebarProjetos";

function Projetos() {
  return (
    <div className="flex h-screen">
      <SidebarProjetos />
      <div className="flex-grow flex flex-col items-center bg-gray-50">
        <Outlet />
      </div>
    </div>
  );
}

export default Projetos;
